import base from './base'
export default {
  ...base,
  owner_id: {
    type: ['undefined', 'string']
  },
  name: {
    type: ['undefined', 'string']
  },
  owner_type: {
    type: ['string'],
    default: () => 'STORY'
  },
  sections: {
    type: ['array'],
    default: () => []
  },
  story: {
    type: ['object'],
    default: () => {}
  }
}
